<div class="board-header">
  <div class="board-bar">

    <div class="board-button">
      <app-users-filter (updateRoles)="updateRoles($event)" [selectedRoles]="usersString"></app-users-filter>
      <!-- <div class="board-button-label" (click)="toggleActiveButton()">Show Inactive</div> -->
    </div>
    <div class="board-button">
      <button mat-button class="create-user-button" (click)="createNewUser()">
        <mat-icon>add</mat-icon>
        <div class="button-title">New User</div>
      </button>
    </div>

    <div class="board-button active-inactive">
      <p-checkbox [(ngModel)]="showInActiveUsers" [binary]="true" (onChange)="toggleUsers()"
                  label="Show Inactive">
      </p-checkbox>
    </div>

    <p-autoComplete (onSelect)="openUserFromSearchBar($event)" [suggestions]="searchedUsers" [(ngModel)]="searchValue"
                    (completeMethod)="filterUsers($event)" field="name" [size]="30" placeholder="Search"
                    [minLength]="1">
    </p-autoComplete>
  </div>
</div>
<p-table #ut [value]="users" [paginator]="true" [rows]="usersPerPage" [lazy]="true"
         (onLazyLoad)="loadNewUsersLazy($event)"
         [lazyLoadOnInit]="false" selectionMode="single" [totalRecords]="totalElements"
         (onRowSelect)="openUser($event)" [loading]="loadingUsers">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of cols">
        {{col.header}}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="cols">
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of cols" [ngClass]="rowData.enabled ? 'is-active' : 'non-active'">
        <!-- <td *ngFor="let col of cols" [ngClass]="rowData.active ? 'is-active' : 'non-active'"> -->
        <ng-container>
          <div class="table-div">{{getFieldData(rowData, col)}}</div>
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>
